import React from 'react';
import AvatarEditor from 'react-avatar-editor';

import CircularLoading from '../../../Common/CircularLoading/CircularLoading';
import ModalBase from '../../../ModalBase/ModalBase';

class AvatarEditorModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scale: 1.2,
      rotate: 0,
    };
    this.editor = null;
  }

  setEditorRef = (editor) => {
    this.editor = editor;
  };

  setScaleValue = (event) => {
    this.setState({ scale: Number(event.target.value) });
  };

  setRotateValue = (value) => {
    this.setState({ rotate: Number(this.state.rotate) + Number(value) });
  };

  saveImage = () => {
    if (this.editor) {
      const canvasScaled = this.editor.getImageScaledToCanvas().toDataURL();
      const imgFile = this.dataURLtoFile(canvasScaled, 'png');
      this.props.onSave(imgFile);
    }
  };

  dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    // eslint-disable-next-line prefer-const
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  render() {
    return (
      <ModalBase
        isOpen
        toggle={this.props.onClose}
        header="Edit your profile photo"
        body={
          <>
            <AvatarEditor
              ref={this.setEditorRef}
              image={this.props.selectedImage}
              width={220}
              height={220}
              border={50}
              color={[0, 0, 0, 0.81]}
              scale={this.state.scale}
              rotate={this.state.rotate}
              borderRadius={150}
            />
            <div className="range-container">
              <div className="range-label">scale</div>
              <input
                type="range"
                className="form-control-range"
                id="formControlRange1"
                max="4"
                min="1"
                step="0.01"
                onChange={this.setScaleValue}
                value={this.state.scale}
              />
            </div>
            <div className="range-container">
              <div className="range-label">rotate</div>
              <div className="rotate-buttons">
                <button
                  className="btn btn-outline-secondary rounded-lg rotate-btn"
                  onClick={() => this.setRotateValue(-90)}
                >
                  left
                </button>
                <button
                  className="btn btn-outline-secondary rounded-lg rotate-btn"
                  onClick={() => this.setRotateValue(90)}
                >
                  right
                </button>
              </div>
            </div>
            {this.props.message.text !== '' &&
              this.props.message.type === 'error' && (
                <div className="message-error">{this.props.message.text}</div>
              )}
          </>
        }
        footer={
          <button
            className="btn btn-primary btn-block rounded-sm"
            onClick={this.saveImage}
          >
            {this.props.waiting ? (
              <CircularLoading className="loading-gif-waiting" />
            ) : (
              'Save'
            )}
          </button>
        }
      />
    );
  }
}

export default AvatarEditorModal;
